import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=094f934a&scoped=true"
import script from "./CategoryDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=094f934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f934a",
  null
  
)

export default component.exports